import { ActivityCardHeader, ActivityCardHeaderContent, ActivityCardInfo, ActivityCardTitle } from '@/components/custom/activity';
import { Badge } from '@/components/ui/badge';
import React from 'react';
import { useTranslation } from 'react-i18next';

export function ComplementaryActivityEvaluationCardHeader(props) {
  const { t } = useTranslation();
  const { activity, activityStudent, showStatus } = props;

  const activityStatusClass = () => {
    switch (activityStudent['status']) {
      case 'Avaliação realizada':
        return 'success';
      default:
        return 'default';
    }
  };

  return (
    activity && (
      <ActivityCardHeader>
        <ActivityCardHeaderContent>
          {showStatus && (
            <Badge
              variant={activityStatusClass()}
              size="xs"
            >
              {activityStudent['status']}
            </Badge>
          )}

          <ActivityCardTitle size="md">{activity.title}</ActivityCardTitle>
          <ActivityCardInfo>
            {t('textsCommon.module')} {activity.modulus} | {t('textsCommon.unit')} {activity.unit} | {activity['class-hours'] < 2 ? `${activity['class-hours']} hora` : `${activity['class-hours']} ${t('tasks.hours')}`}
          </ActivityCardInfo>
        </ActivityCardHeaderContent>
      </ActivityCardHeader>
    )
  );
}
